import React from 'react';
import { useAuth } from '../../context/AuthContext'; // Use the custom useAuth hook
import defaultProfilePic from '../../assets/defaultProfilePic.png'; // Corrected path
import './Profile.css'; // Corrected casing
import api from '../../api';
import { getProfilePictureUrl } from '../../utils/apiHelper';

const Profile = () => {
  const { profile, profileLoading } = useAuth(); // Access profile and loading state

  if (profileLoading) {
    return <p>Loading...</p>; // Display a loading state while fetching the profile
  }

  if (!profile) {
    return <p>Please log in to view your profile.</p>; // Show message if the user is not logged in
  }

  const { name, email, phone, profilePicture } = profile; // Destructure profile object

  return (
    <div className="page-container">
      <h1>Profile</h1>
      <p>Manage your personal information and update your profile.</p>
      <div className="profile-container">
        <img
          src={getProfilePictureUrl(profilePicture, api.img, defaultProfilePic, name)} // Show profile picture or default
          alt="Profile"
          className="profile-image1"
        />
        <div className="profile-details">
          <p><strong>Name:</strong> {name}</p>
          <p><strong>Email:</strong> {email}</p>
          <p><strong>Phone:</strong> {phone}</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
